import { modalRenderer } from '~/modal/modalRendererRegistry';
import { FilterSettingsContainer } from './filterSettings.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    FilterSettings: undefined;
  }
}
modalRenderer.register('FilterSettings', FilterSettingsContainer);
